import React, { Component } from 'react'
import { connect } from "react-redux";
//import { DragSource } from 'react-dnd';
import FontAwesome from 'react-fontawesome';

import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../../axios-cmk";
import { addNewVisit, cancelVisit, showPatientDetails, showVisitDetails } from "../../../store/actions"
import ConfirmBox from '../../UI/ConfirmBox/ConfirmBox'
import { Person, Therapy } from "../../../models/models";
import './Terms.css';


const mapDispatchToProps = dispatch => {
    return {
        showTermDetailsAction: (cell) => dispatch(showVisitDetails(cell)),
        addNewVisit: (cell) => dispatch(addNewVisit(cell)),
        cancelVisit: (id, paid, permanent) => dispatch(cancelVisit(id, paid, permanent)),
        showPatientDetails: (patient_id) => dispatch(showPatientDetails(patient_id))
    }
};

class ToolBoxStateless extends Component {

    state = {
        deleteConfirmationOpened: false,
    };

    onDeleteRequestHandle = (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.setState(
            { deleteConfirmationOpened: true }
        );
    };

    onModalClose = () => {
        this.setState(
            { deleteConfirmationOpened: false }
        )
    };

    onDeleteConfirmedFree = () => {
        this.props.onDelete(this.props.visit.id, false, false);
        this.onModalClose()
    }

    onDeleteConfirmedPaid = () => {
        this.props.onDelete(this.props.visit.id, true, false);
        this.onModalClose()
    }

    onDeletePermanent = () => {
        this.props.onDelete(this.props.visit.id, true, true);
        this.onModalClose()
    }

    onAddNewVisitClicked = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.addNewVisit(this.props.parent_cell)
    }

    odShowPatientDetailsClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.showPatientDetails(this.props.visit.patient.id)
    }

    render() {

        const add_visit = this.props.addEnabled ?
            <FontAwesome name='calendar-plus-o' className='action' onClick={this.onAddNewVisitClicked} />
            : <span className="icon"></span>

        const confirms = (this.props.visit.is_vacation || this.props.visit.is_blocked) ?
            [{
                onClick: this.onDeletePermanent,
                label: <FontAwesome name='trash' />,
                styleName: 'danger'
            }] :
            (this.props.visit.is_canceled ? [{
                    onClick: this.onDeleteConfirmedFree,
                    label: 'Ukryj odwołaną wizytę',
                    styleName: 'success'
                }] :
                [
                    {
                        onClick: this.onDeletePermanent,
                        label: <FontAwesome name='trash' />,
                        styleName: 'danger'
                    },
                    {
                        onClick: this.onDeleteConfirmedPaid,
                        label: 'Rezygnacja płatna',
                        styleName: 'warning'
                    },
                    {
                        onClick: this.onDeleteConfirmedFree,
                        label: 'Rezygnacja darmowa',
                        styleName: 'success'
                    },
                ])

        const patient_details = this.props.visit.patient ?
            <FontAwesome name='address-card' className='action' onClick={this.odShowPatientDetailsClick} /> : ''
        return (
            <div className='toolBox no-print'>
                {patient_details}
                <div className='actionBox'>
                    {add_visit}
                    {this.state.deleteConfirmationOpened}
                    <FontAwesome name='trash' className='action' onClick={this.onDeleteRequestHandle} />
                </div>
                <ConfirmBox
                    modal={this.state.deleteConfirmationOpened}
                    onConfirms={confirms}
                    onCancel={this.onModalClose}
                />
            </div>
        )
    }
}

const ToolBox = connect(null, mapDispatchToProps)(
    ToolBoxStateless
);

class HoveredCell extends Component {

    state = {
        cellOvered: false
    };

    get_therapist = () => this.props.visit ?
        Object.assign(new Person(), this.props.visit.therapist) : this.props.therapist;

    get_hour = () => this.props.hour;

    highlightCell = () => {
        this.setState({ cellOvered: true });
    };

    hideCell = () => {
        this.setState({ cellOvered: false });
    }
}

class AddTermButton extends HoveredCell {

    render() {
        const cellClass = 'personTermCell ' + (this.state.cellOvered ? "selected" : "deselected");
        const addStyle = 'add-term ' + (this.state.cellOvered ? 'active' : 'inactive')
        return (
            <div className={cellClass}
                 onMouseEnter={this.highlightCell}
                 onMouseLeave={this.hideCell}
                 onClick={() => this.props.addNewVisit(this)}>
                <div className={addStyle}>
                    <FontAwesome name='calendar-plus-o' className='action no-print' />
                </div>
            </div>
        )
    }
}

class PersonTermDetailedContainerStateless extends HoveredCell {

    get_visit = () => this.props.visit;

    get_hours_styles = () => {
        let result = []
        return result
    };

    render() {
        const patient = this.props.visit.patient ? this.props.visit.patient : {
            'id': 0,
            'name': 'pacjent',
            'last_name': 'Nieznany',
            'age': {
                'years': 0,
                'months': 0
            }
        };
        const cellClass = ['personTermCell',
            this.state.cellOvered ? "selected" : "deselected",
            patient ? (patient.regular ? "regularPatient" : "occasionalPatient") : 'unknownPatient',
            this.props.visit.status].concat(this.get_hours_styles()).join(' ')

        const toolBoxStyle = this.state.cellOvered ? "toolBoxContainer show-toolbar" : "toolBoxContainer hide-toolbar"

        const visit_canceled = this.props.visit.status.startsWith('canceled')
        let cell_height = this.props.visit.duration_hours * 76;
        cell_height += this.props.visit.duration_hours > 1 ? parseInt(this.props.visit.duration_hours, 10) * 5 : 0;
        const margin = this.props.visit.minute_start / 60 * 80
        const regular_patient = patient && patient.regular ? (
            <FontAwesome name='star' />
        ) : '';
        if (this.props.visit.is_not_available()) {
            const label = this.props.visit.get_vacation_label();
            const icon = this.props.visit.is_vacation ? 'briefcase' : 'ban';
            return (
                <div className={cellClass}
                     onMouseEnter={this.highlightCell}
                     onMouseLeave={this.hideCell}
                     therapy={this.props.visit.id}
                     style={{ height: cell_height, marginTop: margin }}>
                    <div className="lockTerm">
                        <FontAwesome name={icon} className='action no-print' />
                        {label}
                    </div>
                    <div className={toolBoxStyle}>
                        <ToolBox
                            visit={this.props.visit}
                            onDelete={this.props.cancelVisit}
                            addEnabled={visit_canceled}
                            addNewVisit={this.props.addNewVisit}
                            parent_cell={this} />
                    </div>
                </div>
            )
        }


        return (
            <div className={cellClass}
                 onClick={() => this.props.showTermDetailsAction(this)}
                 onMouseEnter={this.highlightCell}
                 onMouseLeave={this.hideCell}
                 style={{ height: cell_height, marginTop: margin }}
                 therapy={this.props.visit.id}>
                <div className='patientLastName'>{patient.last_name}
                    <div className='regularPatientSign'>{regular_patient} </div>
                </div>
                <div className='patientName'>{patient.name} </div>


                <div className='patientAgeM'>({patient.age.months})</div>
                <div className='patientAgeY'>
                    <small>wiek:</small>
                    {patient.age.years}</div>

                <div className='therapyEnd'>{this.props.visit.time_start} - {this.props.visit.time_end}</div>
                <div className={toolBoxStyle}>
                    <ToolBox
                        visit={this.props.visit}
                        onDelete={this.props.cancelVisit}
                        addEnabled={visit_canceled}
                        addNewVisit={this.props.addNewVisit}
                        parent_cell={this} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        therapists: state.cmk.therapists,
        hours: state.cmk.hours,
        patients: state.patients.patients,
        therapies: state.cmk.therapies,
        visits: state.cmk.visits
    };
}

const PersonTermDetailedContainer = connect(mapStateToProps, mapDispatchToProps)(
    PersonTermDetailedContainerStateless
);

const AddTermButtonContainer = connect(mapStateToProps, mapDispatchToProps)(
    AddTermButton
);


class PersonTermCell extends Component {
    state = {
        showDetails: false
    };

    render() {
        let content = '';
        const cell_key = this.props.hour + "_" + this.props.therapist.id
        if (this.props.hour.key in this.props.visits) {
            const hour_maps = this.props.visits[this.props.hour.key][this.props.therapist.id];
            content = hour_maps.map(hour_map => {
                if (hour_map === 0) {
                    return <AddTermButtonContainer key={cell_key} hour={this.props.hour}
                                                   therapist={this.props.therapist} />
                } else if (hour_map === 0.5 || hour_map === 1) {
                    return ''
                } else {
                    const visit = Object.assign(new Therapy(), hour_map);
                    return <PersonTermDetailedContainer key={cell_key} visit={visit} hour={this.props.hour} />
                }
            })
        } else {
            content = <AddTermButtonContainer hour={this.props.hour} therapist={this.props.therapist} />
        }
        return (
            <div>
                {content}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(PersonTermCell, axios));


// WEBPACK FOOTER //
// ./src/components/Calendar/Terms/Terms.js